import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { getErrorMessage } from "../../utils/errorUtils";
import * as actions from "../slices/receipt";

export const getReceipts =
  ({ search = "", startDate, endDate, page = 1, size = 10 }) =>
  async (dispatch) => {
    dispatch(actions.setLoadingReceipts());
    try {
      const params = { page, size, startDate, endDate };
      if (search) params.search = search;
      const { data } = await axiosInstance.get("/receipts", {
        params,
        headers: { requiresAuth: true },
      });
      if (data.status === "SUCCESS") {
        dispatch(
          actions.setReceipts({
            content: data.data.content,
            pagination: data.data.pagination,
          }),
        );
      }
    } catch (error) {
      dispatch(actions.setErrorLoadingReceipts(getErrorMessage(error)));
    }
  };

export const getReceiptById = (id) => async (dispatch) => {
  dispatch(actions.setLoadingReceipt());
  try {
    const { data } = await axiosInstance.get(`/receipts/${id}`, {
      headers: { requiresAuth: true },
    });
    if (data.status === "SUCCESS")
      dispatch(actions.setCurrentReceipt(data.data));
  } catch (error) {
    dispatch(actions.setErrorLoadingReceipt(getErrorMessage(error)));
  }
};

export const getReceiptPdf = (id) => async (dispatch) => {
  dispatch(actions.setLoadingPdf());
  try {
    const { data } = await axiosInstance.get(`/receipts/pdf/${id}`, {
      headers: { requiresAuth: true },
      responseType: "blob",
    });
    const pdfBlobUrl = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" }),
    );
    dispatch(actions.setPdfUrl(pdfBlobUrl));
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error("Failed to load PDF preview: " + msg);
    dispatch(actions.setErrorLoadingPdf(msg));
  }
};

export const emailReceipt = (id, emailPayload) => async (dispatch) => {
  dispatch(actions.setLoadingEmail());
  try {
    const { data } = await axiosInstance.post(
      `/receipts/email/${id}`,
      emailPayload,
      { headers: { requiresAuth: true } },
    );
    if (data.status === "SUCCESS") {
      toast.success(data.message || "Receipt emailed successfully!");
      dispatch(actions.setEmailSuccess());
      dispatch(
        actions.setServerResponseStatus({
          operation: "email",
          status: data.statusCode,
        }),
      );
      return true;
    }
  } catch (error) {
    const msg = getErrorMessage(error);
    toast.error(msg);
    dispatch(actions.setErrorEmailing(msg));
    return false;
  }
};

export const resetReceiptServerStatus = () => (dispatch) => {
  dispatch(actions.setServerResponseStatus(null));
};
